<template>
  <page-section title="Actu-SPIADI">
    <div>
      <video-display v-model="videoData.show"
                     :source="videoData.source">
      </video-display>
      <div class="col-xs-12 intro text-center">
        <span v-html="intro"></span>
        <hr>
      </div>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-md-6 col-md-push-3">
            <h3 class="text-center">Filtre</h3>
            <textarea class="form-control editor" rows="1"
                      v-model.trim="currentFilter"
                      placeholder="Rechercher une vidéo par contenu..."
                      @keydown.enter.exact.prevent>
            </textarea>
            <hr>
          </div>
        </div>
      </div>
      <div v-for="(l, k) in list"
           class="col-xs-12 col-md-6 video-item"
           :key="`video-${k}`">
        <btn type="default" class="bigbtn"
             :class="l.type ? `border-${l.type}` : ''" block
             @click="showVideo(l)">
          <ul>
            <li v-for="(t, x) in l.title"
                :key="`video-${k}-${x}`">
              <span v-html="t"></span>
            </li>
          </ul>
          <div class="text-right video-item-date"
               :class="`label label-${l.type}`">
            <strong>{{ l.date }}</strong>
          </div>
        </btn>
      </div>
    </div>
  </page-section>
</template>

<script>
import pageSection from '@/components/pagesection'
import videoFrame from '@/components/videoFrame'
import suiLoadingText from '@/sui/components/loadingtext'
import videoDisplay from '@/components/help/videodisplay'
import { mapState } from 'vuex'

import filter from '@/sui/tools/filter'

export default {
  name: 'news',

  data: function () {
    return {
      currentFilter: '',
      collapse: null,
      isReady: false,
      currentFocus: null,
      ctest: false,
      videoData: {
        source: null,
        show: false
      }
    }
  },

  computed: {
    ...mapState({
      news: state => state.cloud.cfg.news
    }),

    filterTest: function () {
      if (this.currentFilter === '') {
        return null
      }

      return filter.build({}, this.currentFilter)
    },

    intro: function () {
      if (this.news == null) {
        return null
      }

      return this.news.intro.join(' ')
    },

    list: function () {
      const expr = (this.filterTest != null && this.filterTest.error == null)
        ? this.filterTest : () => true
      const result = []
      for (let y of this.news.videos.years) {
        for (let m of y.months) {
          for (let l of m.links) {
            if (expr(
              {
                filterlabel: l.title.join('\n')
              }
            )) {
              result.push(l)
            }
          }
        }
      }
      return result
    }
  },

  methods: {
    showVideo: function (l) {
      this.videoData.source = l
      this.videoData.show = true
    }
  },

  components: {
    'page-section': pageSection,
    'video-display': videoDisplay,
    videoFrame,
    suiLoadingText
  }
}
</script>
<style lang="less" scoped>
@import '~variables';

.intro {
  font-size: 120%;
}

.video-item {
  .video-item-date {
    position: absolute;
    top: 0.2rem;
    right: 1.7rem;
    border-top-left-radius: 0rem;
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
    text-align: right;
    display: inline;
    font-size: 100%;
  }

  .bigbtn {
    word-wrap: break-word;
    white-space: normal;
    margin-bottom: 1rem;
    min-height: 12rem;
    vertical-align: top;
    text-align: left;
    border-width: 2px;
    margin-bottom: 2rem;

    ul {
      padding-left: 2rem;
      list-style-type: circle;
      li {
        font-size: 110%;
      }
    }

    &:hover {
      .video-item-date {
        background-color: darken(@btn-default-bg, 32%);
      }
    }
  }
}
</style>
<style lang="less">
#help {
  .actu-date {
    text-align: center;
    border-radius: 0.4rem;
    width: 15rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0.1rem;
    display: block;
    font-weight: bold;
  }
}
</style>
